//Esta vista corresponde a la pantalla de inversion por objetivos de GBI
require('sass/blocks/personal-data-view.scss');
//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
// @ components
const { ProfileGbiInvestment } = require('components/newAccountSteps/profileSteps/profileGbiInvestment');
const WelcomeCard = require('components/welcomeCard/welcomeCard').welcomeCard;
//@actions
const stepsActions = require('actions/stepsActions');

class GbiInvestmentView extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="profesional-data-view">
                <ProfileGbiInvestment />
                <WelcomeCard />
            </div>
        );
    }
}

module.exports.constructor = GbiInvestmentView;
module.exports.GbiInvestmentView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        errorState: state.error,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
    })
)(GbiInvestmentView);
